import React from "react";
import {
  Tabs
} from "antd";
import { useTranslation } from "react-i18next";
import ListDevice from "./ListDevice";
import { ALL_PERMISSION } from "constants/permission";
import BasicTabs from "components/BasicTabs";
const { TabPane } = Tabs;

export default function ListDevicePay() {
  const { t: translation } = useTranslation();

  const listTab = [{
      key: "listDevice",
      label :translation("new.list"),
      permission: undefined,
      component: <ListDevice />,
    }
  ]
  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGEMENT_DEVICE.permissionTab} />
  );
}